import { Observable } from "rxjs";
import HttpService from "./HttpService"; 
import { url } from "./APIEndPoints";
import { buildParamString, IAPICommonResponse, IAPIResponse } from "@mindmemobile/mm-shared-global";
import { IAPICreateEditPaymentResponseModel, IAPIPaymentDetailPageModel, IAPIPaymentGridModel, IAPIPaymentRefundModel, IAPIUpsertPaymentModel } from "../interfaces/IAPIPaymentModels";

class PaymentService {
    private httpService: HttpService;
    constructor() {
        this.httpService = new HttpService(
            undefined,
            `${process.env.REACT_APP_API_KEY}`,
            process.env.REACT_APP_API_BASE_URL,
        );
    }
    getPayments(
        accountId: string,
        pageNumber: number,
        pageSize: number,
        searchValue: string,
    ): Observable<IAPIResponse<IAPIPaymentGridModel[]>> {
        const params: string = buildParamString({
            accountId: accountId,
            pageNumber: pageNumber,
            pageSize: pageSize,
            searchValue: searchValue,
        });
        return this.httpService.get<IAPIResponse<IAPIPaymentGridModel[]>>(url.payments, params);
    }

    getPayment(
        accountId: string,
        paymentId: string,
        searchValue: string,
    ): Observable<IAPIResponse<IAPIPaymentDetailPageModel>> {
        const params: string = buildParamString({
            accountId: accountId,
            id: paymentId,
            searchValue: searchValue,
        });
        return this.httpService.get<IAPIResponse<IAPIPaymentDetailPageModel>>(url.getPayment, params);
    }

    savePayment(data: IAPIUpsertPaymentModel): Observable<IAPIResponse<IAPICreateEditPaymentResponseModel>> {
        return this.httpService.post<IAPIResponse<IAPICreateEditPaymentResponseModel>>(url.newPayment, data);
    }

    updatePayment(data: IAPIUpsertPaymentModel): Observable<IAPIResponse<IAPICreateEditPaymentResponseModel>> {
        return this.httpService.put<IAPIResponse<IAPICreateEditPaymentResponseModel>>(url.updatePayment, data);
    }

    refundPayment(data: IAPIPaymentRefundModel): Observable<IAPIResponse<IAPICommonResponse>> {
        return this.httpService.post<IAPIResponse<IAPICommonResponse>>(url.refundPayment, data);
    }

    cancelPayment(id: string, accountId: string): Observable<IAPIResponse<IAPICommonResponse>> {
        const request = {
            id: id,
            accountId: accountId,
        };
        return this.httpService.put<IAPIResponse<IAPICommonResponse>>(url.cancelPayment, request);
    }

    voidPayment(paymentTransactionId: string, accountId: string): Observable<IAPIResponse<IAPICommonResponse>> {
        const request = {
            paymentTransactionId: paymentTransactionId,
            accountId: accountId,
        };
        return this.httpService.put<IAPIResponse<IAPICommonResponse>>(url.voidPayment, request);
    }
}
export default new PaymentService();
